<template>
  <div class="mes-sidebar">
    <div class="mes-sidebar__header">
      <p v-if="isCollapse">
        <img :src="require('@/assets/images/logo-small.png')" alt="logo" />
      </p>
      <p v-else>{{ systemName }}</p>
    </div>
    <div class="mes-sidebar__content scrollbar-hide">
      <el-menu
        :default-active="activeMenu"
        :text-color="variables.menuFontColor"
        :background-color="variables.menuBackgroundColor"
        :active-text-color="variables.menuHoverFontColor"
        :collapse-transition="false"
        :collapse="isCollapse"
        unique-opened>
        <sidebar-item
          v-for="item of menu"
          :key="item.path"
          :item="item"
          :base-path="item.path"
        />
      </el-menu>
    </div>
  </div>
</template>

<script>
import sidebarItem from './sidebar-item';
import variables from '@/scss/variables.scss';
import { systemName } from '@/config';
import { mapGetters } from 'vuex';

export default {
  name: 'Aside',
  components: {
    sidebarItem
  },
  data() {
    return {
      systemName
    };
  },
  computed: {
    ...mapGetters([
      'open',
      'menu'
    ]),
    // 是否水平折叠收起菜单
    isCollapse() {
      return !this.open;
    },
    // 变量
    variables() {
      return variables;
    },
    // 当前激活菜单的 index
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      return meta.activeMenu ? meta.activeMenu : path;
    }
  }
};
</script>